var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CChartLine',{attrs:{"datasets":_vm.defaultDatasets,"options":_vm.defaultOptions,"labels":['Past Year', 'Same Month Last Year', 'Last Month', 'Current']}})}
var staticRenderFns = []

export { render, staticRenderFns }